(function () {
  'use strict';

  angular
      .module('tfc.retailer.ProductDetail', [])
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('productDetail', {
          parent : 'pageWithMenu',
          url : '/productDetail?brandKey&{styleId:string}&department&category&region&regionDescription&transaction&previousState&sortBy&sortOrder',
          templateUrl : 'ProductDetail/ProductDetail.tmpl.html',
          controller : 'ProductDetailCtrl as vm',
          data : {
            auth : { privilege : 'report.productDetail' },
            requireTerms:true,
            title:'Product Detail',
            path:'productDetail/ProductDetail'
          },
          resolve : {
            brands : function (BrandReports) {
              return BrandReports.findUserBrandNames();
            },
            styleSummary : function (ProductDetail, $stateParams) {
              return ProductDetail.getProductStyleSummary($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction);
            },
            styleSizeAdvice: function (ProductDetail, $stateParams){
              return ProductDetail.getProductStyleSizeAdvice($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction);
            },
            attributeValues : function(ProductDetail, $stateParams){
              return ProductDetail.getPurchaseAttributeStyle($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction, $stateParams.category, $stateParams.department);
            },
            topBrands : function(ProductDetail, $stateParams){
              return ProductDetail.getPurchaseAffinityTopBrands($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction);
            },
            categoryTopBrands : function(ProductDetail, $stateParams){
              return ProductDetail.getPurchaseAffinityCategoryTopBrands($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction, $stateParams.category, $stateParams.department);
            },
            sizeAdvice : function(ProductDetail, $stateParams){
              return ProductDetail.getFitConsistencySizeAdvice($stateParams.brandKey,
                  $stateParams.region, $stateParams.transaction, $stateParams.category, $stateParams.department);
            },
            consumerAgeRange: function(ProductDetail, $stateParams){
              return ProductDetail.getConsumerStylesAgeRange($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction);
            },
            consumerHeight: function(ProductDetail, $stateParams){
              return ProductDetail.getConsumerStylesHeight($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction);
            },
            consumerWeight: function(ProductDetail, $stateParams){
              return ProductDetail.getConsumerStylesWeight($stateParams.brandKey, $stateParams.styleId,
                  $stateParams.region, $stateParams.transaction);
            }
          }
        })
  }

})();